import Router from "@/helpers/router";
import {
  WHATS_NEW_AUDIENCES,
  WHATS_NEW_ICONS,
  WhatsNewEntryI,
} from "@/modules/whats-new/lib/types";

const { CALLER, POD_LEAD } = WHATS_NEW_AUDIENCES;

/**
 * Rewards' launch announcement (C-16 S1, DoD 9b), for callers and Pod Leads
 * (who are callers too; C16-D305). The page ships dark behind
 * `rewards_enabled`, which isn't a `manage/me` feature, so the Rewards source
 * adds this entry only while the rewards probe says on. The window runs from
 * the release to release + 14 days and each caller sees it on two ET days
 * (the default day cap, C16-D425/D426). Team → Incentives' entry is a static
 * entry with `feature: "incentives"` (whats-new/entries).
 */
export const REWARDS_LAUNCH_ENTRY: WhatsNewEntryI = {
  id: "2026-10-27-rewards",
  startsAt: "2026-10-27T04:00:00.000Z",
  endsAt: "2026-11-10T05:00:00.000Z",
  title: {
    [CALLER]: "Rewards are here",
    [POD_LEAD]: "Rewards are here",
  },
  intro: {
    [CALLER]:
      "Every contest you can earn now lives in the app, with your standing as it moves.",
    [POD_LEAD]:
      "Every contest you can earn now lives in the app, with your standing as it moves.",
  },
  sections: [
    {
      id: "rewards",
      audiences: [CALLER, POD_LEAD],
      icon: WHATS_NEW_ICONS.TROPHY,
      title: "Rewards, under Performance",
      items: [
        "See the contests that are running, the ones coming up and the ones that ended.",
        "Each one shows your progress, your place and what you've earned so far.",
        "Open a contest for the full standings and the meetings that count for you.",
      ],
      link: { label: "Open Rewards", href: Router.rewards() },
    },
    {
      id: "reward-bells",
      audiences: [CALLER, POD_LEAD],
      icon: WHATS_NEW_ICONS.BELL,
      title: "Bells",
      items: ["One when a new contest starts, and one when you win a prize."],
    },
  ],
};
